export default "__VITE_ASSET__cuWOmZrw__"